export enum UserOSType {
  Android,
  CrOS,
  Windows,
  IOS,
  Default,
}
